import { BridgeDatasource, HasuraBaseQuery } from '@anduin/shared';
import { IServerSideGetRowsParams } from 'ag-grid-community';
import { Apollo } from 'apollo-angular';
import { OutboundEmailRow } from '../../../models';
import { applyRequestSnapshot, TableRequestSnapshot } from '../../../utils';
import { flattenOutboundEmailRows } from '../utils/sent-table-export-params';

export class EmailDeliveryHubExportDataSource extends BridgeDatasource<OutboundEmailRow> {
  constructor(
    apollo: Apollo,
    baseQuery: HasuraBaseQuery,
    private readonly requestSnapshot: TableRequestSnapshot,
  ) {
    super(apollo, baseQuery);
  }

  getRows(params: IServerSideGetRowsParams): void {
    super.getRows({
      ...applyRequestSnapshot(params, this.requestSnapshot),
      success: ({ rowData }) => {
        const flattenedRows = flattenOutboundEmailRows(rowData ?? []);
        params.success({ rowData: flattenedRows, rowCount: flattenedRows.length });
      },
    });
  }
}
